/**
 * The width resolution where gallery and layout changes
 * @type {number}
 */
const horizontalGalleryBreakpoint = 991

export default horizontalGalleryBreakpoint
